module.exports = __webpack_public_path__ + "media/images/sports_coaching/cover-mobile@2x-6a499268be339092d65bb65b0b0a5b23.jpg";